var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Components/customSelect.scss";
var options = [
    { label: "Above", value: "Above" },
    { label: "Below", value: "Below" },
];
var CustomSelect = function (_a) {
    var updateSelectAumSize = _a.updateSelectAumSize, selectedValue = _a.selectedValue;
    var _b = __read(useState(selectedValue == "Below" ? options[1] : options[0]), 2), selected = _b[0], setSelected = _b[1];
    var _c = __read(useState(false), 2), isOpen = _c[0], setIsOpen = _c[1];
    return (React.createElement("div", { className: "custom-select" },
        React.createElement("div", { className: "select-box", onClick: function () { return setIsOpen(!isOpen); } }, selected === null || selected === void 0 ? void 0 :
            selected.value,
            React.createElement("span", { className: "arrow ".concat(isOpen ? "open" : "") },
                React.createElement("svg", { width: "8", height: "4", viewBox: "0 0 8 4", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                    React.createElement("path", { d: "M4.00002 0C4.12547 0 4.25091 0.0480189 4.34656 0.143855L7.3564 3.16112C7.54787 3.35306 7.54787 3.66425 7.3564 3.85611C7.16501 4.04796 6.85465 4.04796 6.66317 3.85611L4.00002 1.18626L1.33686 3.85601C1.14539 4.04787 0.835056 4.04787 0.643684 3.85601C0.452126 3.66416 0.452126 3.35296 0.643684 3.16103L3.65348 0.143761C3.74917 0.04791 3.87461 0 4.00002 0Z", fill: "#444444" })))),
        isOpen && (React.createElement("ul", { className: "select-dropdown" }, options.map(function (option) { return (React.createElement("li", { key: option.value, className: "option ".concat((selected === null || selected === void 0 ? void 0 : selected.value) === (option === null || option === void 0 ? void 0 : option.value) ? "active" : ""), onClick: function () {
                setSelected(option);
                updateSelectAumSize(option);
                setIsOpen(false);
            } }, option === null || option === void 0 ? void 0 : option.value)); })))));
};
export default CustomSelect;
